<template>
  <v-dialog
    v-model="dialog"
    max-width="700"
    :fullscreen="isMobile()"
    scrollable
  >
    <v-card>
      <toolbar-card-visita :opcao_checklist="checklist" />

      <v-card-text class="pt-5">
        <v-row>
          <v-col>
            <input
              ref="anexarDieta"
              accept="application/pdf"
              type="file"
              v-show="false"
              @change="onSelect()"
            />
            <v-list-item class="grey lighten-4 mt-4">
              <i v-if="carregandoDieta">Carregando dieta...</i>
              <template v-else>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold"
                    >Dieta pronta</v-list-item-title
                  >

                  <v-list-item-subtitle
                    class="success--text"
                    v-if="arquivoAnexado"
                  >
                    <v-icon color="success" x-small left
                      >mdi-file-check-outline</v-icon
                    >
                    Arquivo anexado
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-else>
                    Anexe o arquivo da dieta final recomendada, se disponível.
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-row v-if="arquivoAnexado">
                    <v-btn
                      icon
                      color="grey"
                      title="Visualizar dieta"
                      @click="abrirPreview(arquivoAnexado)"
                      ><v-icon>mdi-eye</v-icon></v-btn
                    >
                    <v-btn
                      icon
                      color="error"
                      title="Remover dieta"
                      @click="removerDieta()"
                      ><v-icon>mdi-trash-can-outline</v-icon></v-btn
                    >
                  </v-row>
                  <v-btn icon v-else @click="$refs.anexarDieta.click()"
                    ><v-icon>mdi-upload</v-icon></v-btn
                  >
                </v-list-item-action>
              </template>
            </v-list-item>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <!-- Botão que revela/esconde o mini-form -->
            <v-btn
              block
              outlined
              color="primary"
              class="mb-3"
              @click="toggleAdd()"
            >
              <v-icon left>{{ adding ? "mdi-close" : "mdi-plus" }}</v-icon>
              {{ adding ? "Fechar" : "Adicionar lote" }}
            </v-btn>

            <!-- MINI-FORM INLINE -->
            <v-expand-transition>
              <div v-if="adding" class="pa-3 grey lighten-4 rounded-lg mb-3">
                <v-form ref="formAdd" @submit.prevent="salvarLote">
                  <v-text-field
                    v-model="novoLote"
                    label="Lote"
                    outlined
                    :rules="[(v) => !!v || 'Informe o nome do lote']"
                    dense
                    clearable
                    autofocus
                    class="font-weight-medium"
                    @keydown.enter.prevent="salvarLote"
                  />
                  <div class="text-right">
                    <v-btn text @click="toggleAdd(false)">Cancelar</v-btn>
                    <v-btn
                      color="success"
                      class="font-weight-bold"
                      @click="salvarLote"
                    >
                      Confirmar
                    </v-btn>
                  </div>
                </v-form>
              </div>
            </v-expand-transition>

            <!-- LISTA DE LOTES -->
            <v-expansion-panels flat multiple v-model="panels">
              <v-expansion-panel
                v-for="(lote, i) in visita.lotes"
                :key="i"
                class="grey lighten-4 mb-1"
              >
                <v-expansion-panel-header class="pt-1 pb-1">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-bold">
                        {{ lote.lote }}
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-row>
                        <v-col>
                          <v-btn
                            small
                            color="primary"
                            @click.stop="
                              $router.push({
                                path: `${$route.path}/${i}/adicionar-alimento`,
                              })
                            "
                          >
                            <v-icon small>mdi-plus</v-icon>
                          </v-btn>
                          <v-btn
                            title="Remover lote"
                            color="error"
                            small
                            class="ml-1"
                            @click.stop="removerLote(i)"
                          >
                            <v-icon small>mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-list-item-action>
                  </v-list-item>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <v-list>
                    <p v-if="lote.itens.length === 0" class="text-center mt-2">
                      <i>Nenhum item adicionado</i>
                    </p>
                    <v-list-item
                      v-else
                      v-for="(item, j) in lote.itens"
                      :key="j"
                      :style="{ 'max-height': '30px' }"
                    >
                      <v-list-item-avatar>
                        {{ item.qtde }} {{ item.embalagem }}
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="subtitle-2">
                          {{ item.descricao_alimento }}
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn
                          icon
                          color="error"
                          title="Remover alimento"
                          @click="visita.lotes[i].itens.splice(j, 1)"
                        >
                          <v-icon>mdi-delete-outline</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>

        <v-row class="mt-5">
          <v-col cols="12">
            <btn-salvar-dados-visita />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- mantém as rotas-filhas, se existirem -->
    <router-view></router-view>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import BtnSalvarDadosVisita from "./BtnSalvarDadosVisita.vue";
import ToolbarCardVisita from "./ToolbarCardVisita.vue";
import { toBase64 } from "@/global";

export default {
  components: { ToolbarCardVisita, BtnSalvarDadosVisita },
  computed: {
    ...mapState("visitaTecnica", ["visita"]),
    arquivoAnexado() {
      return this.visita.docs.find(
        (d) => d.categoria.toLowerCase() === this.categoria
      );
    },
  },
  data: () => ({
    dialog: false,
    checklist: { descricao: "Dieta Sugerida", icone: "mdi-nutrition" },
    panels: [],
    // estado do mini-form
    adding: false,
    novoLote: "",
    categoria: "dieta",
    carregandoDieta: true,
  }),
  watch: {
    dialog(open) {
      if (!open) this.$router.go(-1);
    },
  },
  methods: {
    ...mapActions("visitaTecnica",["buscarDocsVisitaDB","abrirPreview"]),
    isMobile() {
      return this.$mq === "sm";
    },
    abrirPaineis() {
      this.panels = [...Array(this.visita.lotes.length).keys()].map(
        (_, i) => i
      );
    },
    toggleAdd(force) {
      this.adding = typeof force === "boolean" ? force : !this.adding;
      if (this.adding) {
        this.$nextTick(() => {
          // foca no campo automaticamente quando abrir
          const input = this.$el.querySelector("input");
          input && input.focus();
        });
      } else {
        this.novoLote = "";
      }
    },
    posDieta() {
      return this.visita.docs.findIndex(
        (d) => d.categoria.toLowerCase() == this.categoria
      );
    },
    async onSelect() {
      var base64 = await toBase64(this.$refs.anexarDieta.files[0]);
      var pos = this.posDieta();

      var docUrl = URL.createObjectURL(this.$refs.anexarDieta.files[0]);

      if (pos >= 0) {
        this.visita.docs[pos].documento = base64;
        this.visita.docs[pos].url = docUrl;
      } else {
        this.visita.docs.push({
          id: 0,
          categoria: this.categoria,
          documento: base64,
          doc_url: docUrl,
        });
      }
    },
    async removerDieta() {
      var pos = this.posDieta();
      this.visita.docs.splice(pos, 1);
    },
    salvarLote() {
      if (this.$refs.formAdd && this.$refs.formAdd.validate()) {
        // verifica se já existe um lote com o mesmo nome
        const existe = this.visita.lotes.some((l) => l.lote === this.novoLote);

        if (existe) {
          this.$toasted.error("Já existe um lote com este nome.");
          return;
        }

        this.visita.lotes.push({ lote: this.novoLote, itens: [] });
        const indexNovo = this.visita.lotes.length - 1;
        // abre o painel do lote recém adicionado
        if (!this.panels.includes(indexNovo)) this.panels.push(indexNovo);
        this.novoLote = "";
        this.adding = false;
        // garante que o novo lote esteja visível
        this.$nextTick(() => {
          const headers = this.$el.querySelectorAll(
            ".v-expansion-panel-header"
          );
          headers[indexNovo]?.scrollIntoView({
            block: "center",
            behavior: "smooth",
          });
        });
      }
    },
    removerLote(idx) {
      this.visita.lotes.splice(idx, 1);
      // reindexa os painéis abertos
      this.$nextTick(() => this.abrirPaineis());
    },  
  },
  async mounted() {
    this.dialog = true;
    this.abrirPaineis();
    this.carregandoDieta = true;

    if (this.arquivoAnexado && this.arquivoAnexado.id > 0) {
      await this.buscarDocsVisitaDB(this.arquivoAnexado.id);
    }
    this.carregandoDieta = false;
  },
};
</script>

<style>
/* só pra dar um visual de “cartão” no mini-form */
.rounded-lg {
  border-radius: 12px;
}
</style>
